import { ConfigProvider, Radio } from "antd";
import trans from "../../../utils";

const RadioButton = ({
  title,
  formstyle,
  options,
  value,
  setValue,
  errors,
  touched,
}) => {
  const isError = errors && touched;
  const onChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <div
      className={`position-relative vehicle-input w-100 flex-col gap-2 ${formstyle} ${
        isError ? "form-error" : ""
      }`}
    >
      <label className={`form-label ${isError ? "text-red" : ""}`}>
        {title}
      </label>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#0f6936",
            activeBg: "#0f6936",
            activeBorderColor: "#2e9245",
          },
        }}
      >
        <Radio.Group onChange={onChange} value={value} buttonStyle="outline">
          {options.map((i) => (
            <Radio key={i.value} value={i.value}>
              {i.label}
            </Radio>
          ))}
        </Radio.Group>
      </ConfigProvider>
      {isError && <div className="validation">{trans(errors)}</div>}
    </div>
  );
};

export default RadioButton;
